exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._2Th4MBIOamX4bUUrtgzprL{max-width:28.57143rem;overflow:hidden;padding:2.28571rem 1.78571rem}._2S2y4BA9j5AtC-Gz6QzG4j{min-height:4.57143rem;min-width:4.57143rem}.p3kudkjwk4dPMsVyIVSG1{color:#a4a4a4;font-weight:700;margin:0;text-align:center}._3I-irnWdrn9LZ35SGRf8PT{padding:2.85714rem 0}._3YU63DUSJOFs3rA-0dwr0G{font-size:.85714rem;height:2.85714rem!important;margin-left:.71429rem;margin-right:.71429rem;width:10.71429rem!important}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"HomeworkContentPopup": "_2Th4MBIOamX4bUUrtgzprL",
	"HomeworkContentPopup_loading": "_2S2y4BA9j5AtC-Gz6QzG4j",
	"HomeworkContentPopup_title": "p3kudkjwk4dPMsVyIVSG1",
	"HomeworkContentPopup_content": "_3I-irnWdrn9LZ35SGRf8PT",
	"HomeworkContentPopup_button": "_3YU63DUSJOFs3rA-0dwr0G"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/Homework/HomeworkContentPopup/style.postcss
// module id = 1647
// module chunks = 0